import {
  SHIP_OPTION_GROUP_EGC,
  SHIP_OPTION_GROUP_RETAIL_W_OPTIONS,
  SHIP_OPTION_GROUP_RETAIL_WO_OPTIONS
} from 'constants/shipOptionGroups';

import CondensedDigitalItem from 'components/checkout/caap/spc/reviewitems/CondensedDigitalItem';
import CondensedRetailItems from 'components/checkout/caap/spc/reviewitems/CondensedRetailItems';
import { Row, RowSpan } from 'components/checkout/caap/Layout';
import ShipOptionsSection from 'containers/Checkout/ShipOptionsSection';
import { determineGroupType } from 'helpers/CheckoutUtils';

const CondensedItems = componentParams => {
  const {
    byLineItem = [],
    productsByLineItem
  } = componentParams;

  const shipOptionsContainer = <ShipOptionsSection isCondensed={true} />;

  return (
    <Row desktopOnly={true}>
      <RowSpan span="3">&nbsp;</RowSpan>
      <RowSpan span="8">
        {
          byLineItem.map((deliveryGroup, i) => {
            const group = determineGroupType(productsByLineItem, deliveryGroup);
            switch (group) {
              case SHIP_OPTION_GROUP_RETAIL_W_OPTIONS:
                return <CondensedRetailItems
                  key={`${group}-${i}`}
                  shipOptionsSection={shipOptionsContainer}
                  deliveryGroup={deliveryGroup}
                  hasShipOptions={true}
                  productsByLineItem={productsByLineItem} />;
              case SHIP_OPTION_GROUP_RETAIL_WO_OPTIONS:
                return <CondensedRetailItems
                  key={group}
                  deliveryGroup={deliveryGroup}
                  hasShipOptions={false}
                  productsByLineItem={productsByLineItem} />;
              case SHIP_OPTION_GROUP_EGC:
                return <CondensedDigitalItem
                  key={group}
                  deliveryGroup={deliveryGroup}
                  productsByLineItem={productsByLineItem} />;
              default:
                return null;
            }
          })
        }
      </RowSpan>
    </Row>
  );
};

export default CondensedItems;
